import * as React from 'react';
import { connect } from 'react-redux';

import NextPreviousButtons from '../NextPreviousButtons';

import {
	ToggleSwitch
} from '../../../../components/forms';

interface Props {
	questions: any;
	questionnaire: any;
	onQuestionnaireBlur: (e: any) => Promise<any>;
	onQuestionnaireChange: (value?: {}) => void;
	onQuestionnaireNumberKeyUp: (e: any) => void;
	onQuestionnairePaste: (e: any) => void;
	nextStep: (e: any) => void;
	prevStep: (e: any) => void;
	
}
const Covid19Questions: React.StatelessComponent<Props> = props => {
	const isNextDisabled = function () {
		let valid = true;
		if (props.questionnaire.covidTestedPositive == null
			|| props.questionnaire.covidLikeSymptoms == null
			|| props.questionnaire.covidTravelledOutside == null
			|| props.questionnaire.covidTravelWithAdvisory == null
		) {
			valid = false;
		}
		return !valid;
	};
	return (
		<div>
			<ToggleSwitch
				labelText={props.questions.covidTestedPositive}
				name="covidTestedPositive"
				onChildren="Yes"
				offChildren="No"
				onBlur={props.onQuestionnaireBlur}
				onChange={props.onQuestionnaireChange}
				checked={props.questionnaire.covidTestedPositive}
				className="toggle-yes-no"
			/>
			<ToggleSwitch
				labelText={props.questions.covidLikeSymptoms}
				name="covidLikeSymptoms"
				onChildren="Yes"
				offChildren="No"
				onBlur={props.onQuestionnaireBlur}
				onChange={props.onQuestionnaireChange}
				checked={props.questionnaire.covidLikeSymptoms}
				className="toggle-yes-no"
			/>
			<ToggleSwitch
				labelText={props.questions.covidTravelledOutside}
				name="covidTravelledOutside"
				onChildren="Yes"
				offChildren="No"
				onBlur={props.onQuestionnaireBlur}
				onChange={props.onQuestionnaireChange}
				checked={props.questionnaire.covidTravelledOutside}
				className="toggle-yes-no"
			/>
			<ToggleSwitch
				labelText={props.questions.covidTravelWithAdvisory}
				name="covidTravelWithAdvisory"
				onChildren="Yes"
				offChildren="No"
				onBlur={props.onQuestionnaireBlur}
				onChange={props.onQuestionnaireChange}
				checked={props.questionnaire.covidTravelWithAdvisory}
				className="toggle-yes-no"
			/>
			<NextPreviousButtons nextStep={props.nextStep} prevStep={props.prevStep} isNextDisabled={isNextDisabled} />
		</div>
	);
};

function mapStateToProps(state: any, ownProps: any) {
	return state;
}

export default connect(mapStateToProps)(Covid19Questions);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/quoting/enrollment/create-your-account/basicQuestions/Covid19Questions.tsx